import React from 'react';

class ProductionSidebarImage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
      return(
        <a href={this.props.imageLink}>
            <img src={this.props.image} className="mb-3 h-[82px] w-[96px]" alt={this.props.alt} />
        </a>
      );
    }
  }

  export default ProductionSidebarImage;
